import React, { useContext, useEffect, useState } from "react";
import { countriesList } from "../../../../constants/TextContainer";
import ResultChip from "../../../ResultChip";
import { filterDataContext } from "../../../../App";
import { DownArrowIcon } from "../../../GlobalIcons";
import NoResultFound from "../../../NoResultFound";

const LocationSorting = ({
  filterSearchInput,
  createFilterParams,
  perPage,
}) => {
  const [locationList, setLocationList] = useState([]);
  const { preLoadCities, preLoadVenues, filterLoader } =
    useContext(filterDataContext);
  const itemsPerPage = perPage;
  const [visibleItems, setVisibleItems] = useState(itemsPerPage);

  const getFilteredData = () => {
    let filteredCountries = countriesList.filter((item) => {
      return (
        item.iso.toLowerCase().includes(filterSearchInput.toLowerCase()) ||
        item.country_name
          .toLowerCase()
          .includes(filterSearchInput.toLowerCase())
      );
    });

    let filteredCitiesWithCountries = preLoadCities
      ?.filter((item) => {
        return (
          item.city_Name
            .toLowerCase()
            .includes(filterSearchInput.toLowerCase()) ||
          item.country_Name
            .toLowerCase()
            .includes(filterSearchInput.toLowerCase())
        );
      })
      .map((item) => ({
        city_Name: item.city_Name,
        country: item.country_Name,
      }));
    let filteredVenues = preLoadVenues
      ?.filter((item) => {
        return (
          item.city.toLowerCase().includes(filterSearchInput.toLowerCase()) ||
          item.country
            .toLowerCase()
            .includes(filterSearchInput.toLowerCase()) ||
          item.official_name
            .toLowerCase()
            .includes(filterSearchInput.toLowerCase())
        );
      })
      .map((item) => ({
        city: item.city,
        country: item.country,
        venue_Name: item.official_name,
        venueFilter_id: item.venue_id,
      }));

    const mergedData = [
      ...filteredCountries,
      ...filteredCitiesWithCountries,
      ...filteredVenues,
    ];
    setLocationList(mergedData);
  };

  useEffect(() => {
    getFilteredData();
  }, [filterSearchInput]);

  const showMoreItems = () => {
    const newVisibleItems = visibleItems + itemsPerPage;
    setVisibleItems(Math.min(newVisibleItems, locationList.length));
  };

  useEffect(() => {
    if (filterSearchInput.length > 0) {
      setVisibleItems(itemsPerPage);
    }
  }, [filterSearchInput]);

  return (
    <div
      className="chips_sec"
      style={{ display: "flex", columnGap: "10px", cursor: "pointer" }}
    >
      {locationList &&
        (locationList.length > 0 ? (
          <>
            {locationList.slice(0, visibleItems).map((item, index) => (
              <ResultChip
                name={
                  item.city_Name
                    ? `${item.city_Name} (${item.country})`
                    : item.country_name
                    ? item.country_name
                    : item.venue_Name
                    ? item.venue_Name
                    : ""
                }
                key={index}
                item={item}
                createFilterParams={createFilterParams}
                detail={
                  item.city_Name
                    ? `All venues in ${item.city_Name}`
                    : item.venue_Name
                    ? `${item.city} (${item.country})`
                    : "All Locations"
                }
              />
            ))}
            {locationList.length > 5 && locationList.length > visibleItems ? (
              <button className="view_more_filter" onClick={showMoreItems}>
                View More
                <span>
                  <DownArrowIcon fill={"var(--black)"} />
                </span>
              </button>
            ) : (
              ""
            )}
          </>
        ) : (
          <NoResultFound heading={"No Search Result Found"} />
        ))}
    </div>
  );
};

export default LocationSorting;
